import { noop } from 'lodash-es';
import React from 'react';
import styled, { css } from 'styled-components';

const styles = css`
  background: transparent;
  padding: 0;
  display: inline;
  border: 0;
  color: inherit;
  font-size: inherit;
  cursor: pointer;
  text-decoration: underline;
`;

const BaseLink = styled.a`
  ${styles}
`;
const BaseButton = styled.button`
  ${styles}
`;

interface FjLinkButtonProps extends React.HTMLAttributes<HTMLElement> {
  href?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

const FjLinkButton = ({ onClick = noop, ...rest }: FjLinkButtonProps): React.ReactElement => {
  const props = { onClick, ...rest };
  const shouldRenderLink = !!props.href;
  if (shouldRenderLink) {
    return <BaseLink {...props} />;
  }

  return <BaseButton {...props} />;
};

export default FjLinkButton;
